import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidatorErrorType } from '../../constants/validation-error';

@Pipe({
	name: 'errorMessage',
})
export class ErrorMessagePipe implements PipeTransform {
	transform(
		errors: ValidationErrors | null | undefined,
		validationsMsg: ValidatorErrorType[],
	): string {
		const listErrors = Object.keys(errors || {});

		const msgFound = validationsMsg.find((msg) => listErrors.includes(msg.type));
		return msgFound?.message ?? '';
	}
}
